var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.721,
    height: 17.754,
    viewBox: "0 0 16.721 17.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gas",
    d: "M24.743,1.248a.59.59,0,0,0-.59.59V2.5a.876.876,0,0,0-.246-.039.885.885,0,0,0-.885.885V5.508a.879.879,0,0,0,.3.656V11.8a.59.59,0,1,1-1.18,0V9.59a1.767,1.767,0,0,0-1.623-1.756V1.771A1.772,1.772,0,0,0,18.743,0h-8.36A1.773,1.773,0,0,0,8.612,1.771V15.983a1.772,1.772,0,0,0,1.771,1.77h8.36a1.772,1.772,0,0,0,1.771-1.77V9.03a.583.583,0,0,1,.443.56V11.8a1.77,1.77,0,1,0,3.541,0V6.164a.879.879,0,0,0,.3-.656V4.564a.585.585,0,0,0,.541-.58V1.838A.59.59,0,0,0,24.743,1.248ZM18.674,6.9H10.452V1.91h8.222Z",
    transform: "translate(-8.612)",
    fill: "#acacac"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.760240023acd77353ce58c3a63fd3d61.svg";
export { ForwardRef as ReactComponent };